import React from 'react';

const MissionVision: React.FC = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center space-x-2 mb-4">
            <div className="h-px w-8 bg-blue-600"></div>
            <span className="text-sm font-semibold text-blue-600 uppercase tracking-wider">Our Purpose</span>
            <div className="h-px w-8 bg-blue-600"></div>
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Mission, Vision & Values
          </h2>

          <p className="text-gray-600">
            The guiding principles that drive everything we do
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Mission Card */}
          <div className="bg-white rounded-xl p-8 shadow-lg border border-gray-100 relative overflow-hidden group">
            <div className="absolute -right-8 -bottom-8 w-24 h-24 bg-blue-100 rounded-full opacity-70 group-hover:scale-150 transition-transform duration-500"></div>
            <div className="relative z-10">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
                </svg>
              </div>

              <h3 className="text-xl font-bold text-gray-900 mb-4">Our Mission</h3>

              <p className="text-gray-600 mb-6">
                To empower businesses through innovative technology solutions that drive growth,
                efficiency, and competitive advantage in an ever-changing digital landscape.
              </p>

              <div className="h-px w-full bg-gradient-to-r from-blue-600 to-transparent"></div>
            </div>
          </div>

          {/* Vision Card */}
          <div className="bg-white rounded-xl p-8 shadow-lg border border-gray-100 relative overflow-hidden group">
            <div className="absolute -right-8 -bottom-8 w-24 h-24 bg-indigo-100 rounded-full opacity-70 group-hover:scale-150 transition-transform duration-500"></div>
            <div className="relative z-10">
              <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center mb-6">
                <svg className="w-6 h-6 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                </svg>
              </div>

              <h3 className="text-xl font-bold text-gray-900 mb-4">Our Vision</h3>

              <p className="text-gray-600 mb-6">
                To be the global leader in technology innovation, recognized for our excellence in
                developing solutions that transform industries and improve lives around the world.
              </p>

              <div className="h-px w-full bg-gradient-to-r from-indigo-600 to-transparent"></div>
            </div>
          </div>

          {/* Values Card */}
          <div className="bg-white rounded-xl p-8 shadow-lg border border-gray-100 relative overflow-hidden group md:col-span-2 lg:col-span-1">
            <div className="absolute -right-8 -bottom-8 w-24 h-24 bg-purple-100 rounded-full opacity-70 group-hover:scale-150 transition-transform duration-500"></div>
            <div className="relative z-10">
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-6">
                <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"></path>
                </svg>
              </div>

              <h3 className="text-xl font-bold text-gray-900 mb-4">Our Values</h3>

              <ul className="space-y-3 text-gray-600 mb-6">
                <li className="flex items-center">
                  <div className="w-2 h-2 bg-purple-600 rounded-full mr-2"></div>
                  <span>Innovation - We embrace new ideas and technologies</span>
                </li>
                <li className="flex items-center">
                  <div className="w-2 h-2 bg-purple-600 rounded-full mr-2"></div>
                  <span>Excellence - We strive for the highest quality in everything we do</span>
                </li>
                <li className="flex items-center">
                  <div className="w-2 h-2 bg-purple-600 rounded-full mr-2"></div>
                  <span>Integrity - We operate with honesty and transparency</span>
                </li>
                <li className="flex items-center">
                  <div className="w-2 h-2 bg-purple-600 rounded-full mr-2"></div>
                  <span>Collaboration - We achieve more by working together</span>
                </li>
              </ul>

              <div className="h-px w-full bg-gradient-to-r from-purple-600 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionVision;